import {http, onSuccess, onFail} from './http';

export const konturFocusGet = (eventKey, params) => {
    return http.get(`/api/player/event/${eventKey}/kontur/search/companies`, { params })
        .then(onSuccess, onFail);
};

export const getWidgetRegistrationFields = (widgetKey) => {
    return http.get(`/api/player/event/module/widget/registration/${widgetKey}/registration-fields`)
        .then(onSuccess, onFail);
};

export const getWidgetRegistration = (widgetKey) => {
    return http.get(`/api/player/event/module/widget/registration/${widgetKey}`)
        .then(onSuccess, onFail);
};

export const getWidgetSchedule = (widgetKey) => {
    return http.get(`/api/player/event/module/widget/schedule/${widgetKey}`)
        .then(onSuccess, onFail);
};

export const getWidgetMembers = (widgetKey) => {
    return http.get(`/api/player/event/module/widget/members/${widgetKey}`)
        .then(onSuccess, onFail);
};

export const getWidgetBroadcast = (widgetKey) => {
    return http.get(`/api/player/event/module/widget/player/${widgetKey}`)
        .then(onSuccess, onFail);
};
